export default __webpack_public_path__ + "static/tv-landing-f97b89571f5a865a105b4d7befbdee4b.jpg";